import type { CSSProperties } from 'react';
import type { NombreIcono } from './iconos';

/**
 * Icono del sistema común (Lucide como clases `icon-<nombre>` de comun/iconos.css, sin internet). Solo nombres que
 * existen en iconos.css (lo comprueba una prueba). Decorativo: el texto lo lleva el botón o la etiqueta.
 */
export function Icono({ nombre, tamano, className, style }: { nombre: NombreIcono; tamano?: number; className?: string; style?: CSSProperties }) {
    return <i className={`icon-${nombre}${className === undefined ? '' : ` ${className}`}`} aria-hidden="true" style={tamano === undefined ? style : { fontSize: tamano, ...style }} />;
}
